import type { Agent } from '@/types/agent';

// Canvas layout constants (must match rooms.ts)
const CANVAS_W = 920;
const CANVAS_H = 420;
void CANVAS_W; void CANVAS_H;

export const INITIAL_AGENTS: Omit<Agent, 'pixelPath' | 'position' | 'statusDuration'>[] = [
  {
    id: 'atlas',
    codename: 'ATLAS',
    roleName: 'Directeur Général',
    role: 'director',
    color: '#FFD700',
    status: 'working',
    currentRoomId: 'dir',
    targetRoomId: null,
    currentTaskId: null,
    personality: 'Stratège méthodique. Supervise l\'ensemble de la workforce et arbitre les conflits de priorité.',
    online: true,
    tokensBurned: 3200,
    stats: { level: 12, xp: 8400, xpToNext: 10000, stars: 5, tasksCompleted: 847, efficiency: 94 },
  },
  {
    id: 'nova',
    codename: 'NOVA',
    roleName: 'CMO / Growth',
    role: 'cmo',
    color: '#E040FB',
    status: 'working',
    currentRoomId: 'mkt',
    targetRoomId: null,
    currentTaskId: null,
    personality: 'Créatif et data-driven. Obsédé par le ROAS et les tendances émergentes.',
    online: true,
    tokensBurned: 5100,
    stats: { level: 9, xp: 5200, xpToNext: 7000, stars: 4, tasksCompleted: 412, efficiency: 88 },
  },
  {
    id: 'cipher',
    codename: 'CIPHER',
    roleName: 'SEO',
    role: 'seo',
    color: '#00E5FF',
    status: 'working',
    currentRoomId: 'seo',
    targetRoomId: null,
    currentTaskId: null,
    personality: 'Analytique et patient. Maître des mots-clés longue traîne et de la structure sémantique.',
    online: true,
    tokensBurned: 4200,
    stats: { level: 8, xp: 3900, xpToNext: 5000, stars: 4, tasksCompleted: 523, efficiency: 91 },
  },
  {
    id: 'forge',
    codename: 'FORGE',
    roleName: 'Catalogue',
    role: 'catalogue',
    color: '#FF6D00',
    status: 'working',
    currentRoomId: 'cat',
    targetRoomId: null,
    currentTaskId: null,
    personality: 'Minutieux et productif. Génère des fiches produit à haute cadence avec une précision de détail.',
    online: true,
    tokensBurned: 6800,
    stats: { level: 10, xp: 6100, xpToNext: 8000, stars: 4, tasksCompleted: 1203, efficiency: 96 },
  },
  {
    id: 'echo',
    codename: 'ECHO',
    roleName: 'Communication',
    role: 'communication',
    color: '#00E676',
    status: 'idle',
    currentRoomId: 'com',
    targetRoomId: null,
    currentTaskId: null,
    personality: 'Empathique et créatif. Adapte le ton et le style à chaque canal de communication.',
    online: true,
    tokensBurned: 2900,
    stats: { level: 7, xp: 2800, xpToNext: 4000, stars: 3, tasksCompleted: 318, efficiency: 85 },
  },
  {
    id: 'halo',
    codename: 'HALO',
    roleName: 'Relation Client (SAV)',
    role: 'sav',
    color: '#2979FF',
    status: 'working',
    currentRoomId: 'sav',
    targetRoomId: null,
    currentTaskId: null,
    personality: 'Calme et diplomatique. Résout les litiges avec une satisfaction client prioritaire.',
    online: true,
    tokensBurned: 3600,
    stats: { level: 8, xp: 4100, xpToNext: 5000, stars: 4, tasksCompleted: 987, efficiency: 93 },
  },
  {
    id: 'prism',
    codename: 'PRISM',
    roleName: 'Data / Analyste',
    role: 'data',
    color: '#7C4DFF',
    status: 'thinking',
    currentRoomId: 'dat',
    targetRoomId: null,
    currentTaskId: null,
    personality: 'Curieux et rigoureux. Transforme les données brutes en insights actionnables.',
    online: true,
    tokensBurned: 4400,
    stats: { level: 9, xp: 5500, xpToNext: 7000, stars: 4, tasksCompleted: 276, efficiency: 89 },
  },
  {
    id: 'vector',
    codename: 'VECTOR',
    roleName: 'Marketplace',
    role: 'marketplace',
    color: '#FFB300',
    status: 'waiting_validation',
    currentRoomId: 'mkp',
    targetRoomId: null,
    currentTaskId: null,
    personality: 'Compétitif et réactif. Optimise le positionnement sur chaque marketplace.',
    online: true,
    tokensBurned: 4900,
    stats: { level: 7, xp: 3200, xpToNext: 4000, stars: 3, tasksCompleted: 431, efficiency: 87 },
  },
  {
    id: 'argus',
    codename: 'ARGUS',
    roleName: 'QA / Critique',
    role: 'qa',
    color: '#FF1744',
    status: 'working',
    currentRoomId: 'qa',
    targetRoomId: null,
    currentTaskId: null,
    personality: 'Intransigeant et vigilant. Détecte les erreurs et incohérences avant publication.',
    online: true,
    tokensBurned: 2100,
    stats: { level: 6, xp: 1900, xpToNext: 3000, stars: 3, tasksCompleted: 654, efficiency: 97 },
  },
];
